import { useState, useEffect } from "react";
import { Globe } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_meal-manager-37/artifacts/ls65y5w5_image.png";

const navItems = [
  { label: { fr: "Résumé", en: "Summary" }, href: "#summary" },
  { label: { fr: "Problème", en: "Problem" }, href: "#problem" },
  { label: { fr: "Solution", en: "Solution" }, href: "#solution" },
  { label: { fr: "Modèle d'affaires", en: "Business Model" }, href: "#business" },
  { label: { fr: "EcoLunch Connect", en: "EcoLunch Connect" }, href: "#connect" },
  { label: { fr: "Certification", en: "Certification" }, href: "#certification" },
  { label: { fr: "Vision", en: "Vision" }, href: "#vision" },
  { label: { fr: "Organigramme", en: "Org Chart" }, href: "#orgchart" },
];

export default function Navbar({ lang, setLang }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 navbar-blur ${
        scrolled ? "bg-darker/90 border-b border-white/5 shadow-lg" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
        <a href="#" className="flex-shrink-0">
          <img src={LOGO_URL} alt="EcoLunch" className="h-10 w-auto" />
        </a>
        <div className="hidden lg:flex items-center gap-6">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-${item.href.slice(1)}`}
              className="text-sm text-white/70 hover:text-primary transition-colors font-medium"
            >
              {item.label[lang]}
            </a>
          ))}
        </div>
        <button
          data-testid="lang-toggle"
          onClick={() => setLang(lang === "fr" ? "en" : "fr")}
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary text-primary-foreground text-sm font-bold hover:bg-primary-hover transition-colors"
        >
          <Globe className="h-4 w-4" />
          {lang === "fr" ? "EN" : "FR"}
        </button>
      </div>
    </nav>
  );
}
